import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

function encrypt(data, isObject = false) {
  if (isObject) {
    return AES.encrypt(JSON.stringify(data), process.env.CRYPTO_JS_SECRET_KEY).toString();
  }

  return AES.encrypt(data, process.env.CRYPTO_JS_SECRET_KEY);
}

function decrypt(data, isObject = false) {
  const decryptedData = AES.decrypt(data, process.env.CRYPTO_JS_SECRET_KEY);

  const plainData = isObject ? JSON.parse(decryptedData.toString(Utf8)) : Utf8.stringify(decryptedData);

  return plainData;
}

export {
  encrypt,
  decrypt
}



// WEBPACK FOOTER //
// ./src/helpers/crypto-js/index.js